import React from 'react';
import { useTuneStore } from '../../state/storeTunePrayer';
import { useTimeTableMonth } from '../../state/storeTimeTable';
import Dialog from './Dialog';

type Props = {
	label?: string;
	text?: string;
	className?: string;
	classBtnWrapper?: string;
	onPress?: ( e: React.MouseEvent<HTMLButtonElement> ) => void;
	refUpload?: React.RefObject<HTMLDialogElement>;
};


const Button = ( props: Props ) => {



	return (
		<div
			className={ `${
				props?.classBtnWrapper ? props?.classBtnWrapper : ''
			}` }
		>
			<div>{ props.label }</div>
			<button
				
				onPointerDown={ props.onPress }
				id="button"
				className={ ` ${true ? 'bg-red-500' : ''}  "  !border-none ${
					props?.className ? props?.className : ''
				} drop-shadow-c-dsh-1  w-full bg-white h-9 rounded-[4px] c-mdx:h-10 text-green-700 "` }
			>
				{ props.text }
			</button>
				<Dialog dialogRef={ props.refUpload! } />
		</div>
	);
};

export default Button;
